import { AfterViewInit, Component, Inject, OnDestroy } from '@angular/core';

import { Observable, Subject, Subscription, interval } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { EventBusService, Events } from '../../../technical-modules/events/services/event-bus.service';

import { UserService } from '../../../data-domains/humain/user/services/user.service';

const START_COUNT = 180; 

@Component({
	selector: 'refresh-button',
	templateUrl: 'refresh-button.html',
	styleUrls: ['refresh-button.css'],
})
export class RefreshButtonComponent implements AfterViewInit, OnDestroy {
	
	private timeSubscription: Subscription | null = null;
	private init$ = new Subject<void>();

	isUserCce$!: Observable<boolean>;

	countdown: number = START_COUNT;

	
	constructor(
		@Inject(EventBusService) private eventBusService: EventBusService,

		@Inject(UserService) userService: UserService,
	) {
		let user$ = this.init$.pipe(
			mergeMap(
				() => userService.getCurrentUserTLR()
			)
		);
		
		this.isUserCce$ = user$.pipe(
			map(
				user => user.role === 'CCE'
			)
		);
		
		this.isUserCce$.subscribe(
			(isUserCce) => {
				if (!isUserCce)
					return;
				
				this.timeSubscription = interval(1000).subscribe(
					(activationCount) => {
						this.countdown--;
						
						if (this.countdown === 0) {
							this.demandeRafraichissement();
						}
					}
				);
			} 
		);
	}
	
	ngAfterViewInit() {
		// Cette action est concue pour pallier a un bug du framework qui instancie le composant deux fois
		// et donc menace d'executer la logique du constructeur deux fois
		//
		// Seule celle des deux instances instantiee qui est utilisee dans une vue executera ngAfterViewInit
		// et donc emettera un signal dans this.init$
		//
		// Le constructeur est lui-meme code de maniere a n'executer sa logique qu'a la reception de ce signal
		this.init$.next();
	}
	
	ngOnDestroy() {
		if (this.timeSubscription) {
			this.timeSubscription.unsubscribe();
		}
	}
	
	demandeRafraichissement() {
		this.countdown = START_COUNT;
		this.eventBusService.emit(Events.RefreshDataRequested, null);
	}
}